import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectors } from '../store/dux/feature-flags-dux';

useFeatureFlag.propTypes = {
  name: PropTypes.string.isRequired,
};

export function useFeatureFlag(name) {
  return useSelector(selectors.isEnabled(name));
}
